import RespostaSimNao from './tipos/respostaSimNao';
import RespostaConformeNaoConforme from './tipos/respostaConformeNaoConforme';
import RespostaTexto from './tipos/respostaTexto';
import RespostaMultiplaEscolha from './tipos/respostaMultiplaEscolha';
import RespostaUnicaEscolha from './tipos/respostaUnicaEscolha';

export function renderRespostaPorTipo(tipo, respostas) {
  switch (tipo) {
    case 1:
      return <RespostaSimNao respostas={respostas} />;

    case 2:
      return <RespostaConformeNaoConforme respostas={respostas} />;

    case 3:
      return <RespostaTexto respostas={respostas} />;

    case 4:
      return <RespostaMultiplaEscolha opcoes={respostas} />;

    case 5:
      return <RespostaUnicaEscolha opcoes={respostas} />;

    default:
      return <em>Tipo de questão não suportado</em>;
  }
}
